<!--<button class="accent-fab" mat-mini-fab data-cy="toggle-expand"-->
<!--        [matTooltip]=" ( (areNodesExpanded$ | async ) ? 'TOOLTIP.COLLAPSE_ALL' : 'TOOLTIP.EXPAND_ALL') | translate"-->
<!--        (click)="toggleExpandAll()">-->
<!--  <mat-icon class="toolbar-icon">{{ (areNodesExpanded$ | async) ? 'unfold_less':'unfold_more'}}</mat-icon>-->
<!--</button>-->

@if (buttonMode) {
  <button
    [attr.data-cy]="(areNodesExpanded() ? 'TOOLTIP.COLLAPSE_ALL' : 'TOOLTIP.EXPAND_ALL') | translate"
    [matTooltip]="(areNodesExpanded() ? 'TOOLTIP.COLLAPSE_ALL' : 'TOOLTIP.EXPAND_ALL') | translate"
    class="primary"
    (click)="toggleExpandAll()"
    (keydown.enter)="toggleExpandAll()"
    (keydown.space)="toggleExpandAll()"
  >
    <mat-icon color="primary">{{ areNodesExpanded() ? 'unfold_less' : 'unfold_more' }}</mat-icon>
  </button>
} @else {
  <span (click)="toggleExpandAll()" (keydown.enter)="toggleExpandAll()" (keydown.space)="toggleExpandAll()" tabindex="0">
    {{ ((areNodesExpanded$ | async) ? 'TOOLTIP.COLLAPSE_ALL' : 'TOOLTIP.EXPAND_ALL') | translate }}
  </span>
}
